// | Graphical widgets for Restaumatic.Form, using Bootstrap styling. Applicable in PR and Sites.
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNamedParams from "../Data.NamedParams/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dList from "../Restaumatic.Form.List/index.js";
import * as Restaumatic$dForm$dMapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic$dForm$dTranslated from "../Restaumatic.Form.Translated/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dExtra from "../Specular.Extra/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Specular$dSelect from "../Specular.Select/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
const $LabelMode = tag => ({tag});
const $UseDefault = () => ({tag: "UseDefault"});
const UseDefault = /* #__PURE__ */ $UseDefault();
const LabelDefault = /* #__PURE__ */ $LabelMode("LabelDefault");
const LabelBooleanControl = /* #__PURE__ */ $LabelMode("LabelBooleanControl");
const toGroupNameUseDefault = {toGroupName: v => v.fieldId};
const toGroupNameString = {toGroupName: v => v.value};
const wrapItem = /* #__PURE__ */ Specular$dDom$dElement.el("div")([
  /* #__PURE__ */ Specular$dDom$dElement.attr("style")("margin: 5px; margin-left: 10px; padding: 5px; border: 1px solid black;")
]);
const withNothing = emptyLabel => opts => Data$dSemigroup.concatArray([Specular$dSelect.$Option("SingleOption", {label: emptyLabel, key: Data$dMaybe.Nothing, disabled: false})])(Data$dFunctor.arrayMap(Specular$dSelect.functorOption.map(Data$dMaybe.Just))(opts));
const translatedFieldWrapper = body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("input-group")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.attr("title")("Pole tłumaczone"),
  Specular$dDom$dElement.class_("input-group-addon")
])(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.attr("aria-hidden")("true"), Specular$dDom$dElement.class_("icon-flag")])(Restaumatic$dPrelude$dSpecular.wempty)))(() => body));
const toGroupName = dict => dict.toGroupName;
const sortIcon = /* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dDom$dElement.el("i")([/* #__PURE__ */ Specular$dDom$dElement.class_("icon-sort")])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dExtra.nbsp);
const renderLabelWithMode = dict => dict.renderLabelWithMode;
const renderLabel = dictFieldLabel => dictFieldLabel.renderLabelWithMode(LabelDefault);
const plusIcon = /* #__PURE__ */ Specular$dInternal$dRIO.applyImpl(/* #__PURE__ */ Specular$dInternal$dRIO.mapImpl(v => x => x)(/* #__PURE__ */ Specular$dDom$dElement.el("span")([
  /* #__PURE__ */ Specular$dDom$dElement.attr("aria-hidden")("true"),
  /* #__PURE__ */ Specular$dDom$dElement.class_("icon-plus-sign")
])(Restaumatic$dPrelude$dSpecular.wempty)))(Specular$dExtra.nbsp);
const panelToggle = label1 => forceExpand => body => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(forceExpand))(Specular$dRef.newRef(Specular$dInternal$dRIO.monadEffectRIO)))(expanded => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeDyn_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(b => expanded._2(b$1 => b || b$1))(forceExpand))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel"), Specular$dDom$dElement.class_("panel-default")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel-heading"),
  Specular$dDom$dElement.class_("sortable-handle")
])(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.unlessD({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)(forceExpand)(Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.onClick_(expanded._2(Data$dHeytingAlgebra.boolNot)),
  Specular$dDom$dElement.attr("type")("button"),
  Specular$dDom$dElement.class_("btn"),
  Specular$dDom$dElement.class_("btn-default"),
  Specular$dDom$dElement.class_("btn-sm"),
  Specular$dDom$dElement.class_("pull-right")
])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.attr("aria-hidden")("true"),
  Specular$dDom$dElement.classWhenD(expanded._1)("icon-caret-up"),
  Specular$dDom$dElement.classUnlessD(expanded._1)("icon-caret-down")
])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dExtra.nbsp)(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.whenD({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)(expanded._1)(Specular$dDom$dElement.text("Zwiń")))(() => Specular$dFRP$dExtra.unlessD({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)(expanded._1)(Specular$dDom$dElement.text("Rozwiń"))))))))(() => label1)))(() => Specular$dFRP$dExtra.whenD({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)(expanded._1)(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel-body")])(body))))));
const panel$p = label1 => body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel"), Specular$dDom$dElement.class_("panel-default")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel-heading"),
  Specular$dDom$dElement.class_("sortable-handle")
])(label1))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("panel-body")])(body)));
const panel = classes$p => body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(Data$dSemigroup.concatArray(["panel", "panel-default"])(classes$p))])(Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("panel-body")
])(body));
const panel_ = body => panel([])(body);
const mappingField = dictOrd => dictFieldLabel => label1 => f => renderItem => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["form-group"])])(Specular$dInternal$dRIO.bindImpl(dictFieldLabel.renderLabelWithMode(LabelDefault)(label1))(() => Restaumatic$dForm$dMapping.display(dictOrd)({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)(f)(renderItem)));
const labelWidget = dictTypeEquals => ({renderLabelWithMode: v => Specular$dDom$dBuilder.local(dictTypeEquals.proof(a => a)), isVisible: v => v1 => true});
const labelUnit = {renderLabelWithMode: v => v1 => Restaumatic$dPrelude$dSpecular.wempty, isVisible: v => v1 => false};
const label = /* #__PURE__ */ Specular$dDom$dElement.el("label")([/* #__PURE__ */ Specular$dDom$dElement.class_("control-label")]);
const labelString = {
  renderLabelWithMode: v => v1 => {
    if (v1 === "") { return Restaumatic$dPrelude$dSpecular.wempty; }
    if (v.tag === "LabelDefault") { return label(Specular$dDom$dElement.text(v1)); }
    if (v.tag === "LabelBooleanControl") { return Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("control-label")])(Specular$dDom$dElement.text(v1)); }
    $runtime.fail();
  },
  isVisible: v => v1 => {
    if (v.tag === "LabelDefault") { return !(v1 === ""); }
    return true;
  }
};
const isVisible = dict => dict.isVisible;
const infoText = /* #__PURE__ */ Specular$dDom$dElement.el("p")([/* #__PURE__ */ Specular$dDom$dElement.class_("m-form__info-text")]);
const formGroup = label1 => body => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["form-group"])])(Specular$dInternal$dRIO.bindImpl(label1 !== ""
  ? Specular$dDom$dElement.el("label")([Specular$dDom$dElement.class_("control-label")])(Specular$dDom$dElement.text(label1))
  : Specular$dInternal$dRIO.pureImpl())(() => body));
const fieldset$p = label1 => body => Specular$dDom$dElement.el("fieldset")([Specular$dDom$dElement.class_("form-fieldset")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el_("legend")(label1))(() => body));
const fieldset = label1 => fieldset$p(Specular$dDom$dElement.text(label1));
const displayErrors = dictHasErrors => f => Specular$dFRP$dExtra.withUniqDynamic_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)({eq: Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)})(dictHasErrors.displayedErrors(f))(errors => Data$dFoldable.foldrArray(x => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)(Specular$dDom$dElement.el("p")([
  Specular$dDom$dElement.class_("help-block")
])(Specular$dDom$dElement.text(x))))(b))(Specular$dInternal$dRIO.pureImpl())(errors));
const radioGroup = () => dictHasErrors => dictIsSelectField => dictToOptionId => dictHasFieldId => dictFieldLabel => dictToGroupName => dictShow => dictEq => () => () => params => {
  const $0 = {label: "", props: [], groupName: UseDefault, ...params};
  const field = $0.field;
  return Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["form-group", "form-field"]),
    Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
    Specular$dDom$dElement.attr("data-field-type")("radioGroup"),
    Specular$dDom$dElement.classWhenD(Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors)(field))("has-error")
  ])(Specular$dFRP$dExtra.withUniqDynamic_({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dDom$dBuilder.monadReplaceBuilder)({
    eq: Data$dEq.eqArrayImpl(ra => rb => ra.disabled === rb.disabled && dictEq.eq(ra.key)(rb.key) && ra.label === rb.label)
  })(Specular$dFRP$dBase.functorDynamic.map(Specular$dSelect.flattenOptions)(dictIsSelectField.selectGetOptions(field)))(opts => Data$dFoldable.foldrArray(x => {
    const $1 = Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.class_("radio"),
      Specular$dDom$dElement.attr("data-option-id")(dictToOptionId.toOptionId(x.key))
    ])(Specular$dDom$dElement.el_("label")(Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets.radio(dictShow)(dictEq)(dictIsSelectField)(dictToGroupName.toGroupName({
      fieldId: dictHasFieldId.getFieldId(field),
      value: $0.groupName
    }))(x)($0.props)(field))(() => labelString.renderLabelWithMode(LabelBooleanControl)(x.label)))))(() => displayErrors(dictHasErrors)(field));
    return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)($1))(b);
  })(Specular$dInternal$dRIO.pureImpl())(opts)));
};
const selectField = () => dictIsSelectField => dictHasErrors => dictHasFieldId => dictFieldLabel => dictShow => dictEq => dictToOptionId => () => () => params => {
  const $0 = {label: "", props: [], ...params};
  const field = $0.field;
  return Specular$dDom$dElement.el("div")([
    Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
    Specular$dDom$dElement.class_("form-field"),
    Specular$dDom$dElement.classWhenD(Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors)(field))("has-error")
  ])(Specular$dInternal$dRIO.bindImpl(dictFieldLabel.renderLabelWithMode(LabelDefault)($0.label))(() => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets.select(dictShow)(dictEq)(dictToOptionId)(dictIsSelectField)(Data$dSemigroup.concatArray([
    Specular$dDom$dElement.class_("form-control")
  ])($0.props))(field))(() => displayErrors(dictHasErrors)(field))));
};
const textField$p = dictHasErrors => dictHasFieldId => dictFieldLabel => widget => params => {
  const field = params.field;
  const labelVisible = dictFieldLabel.isVisible(LabelDefault)(params.label);
  return Specular$dDom$dElement.el("div")([
    Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
    Specular$dDom$dElement.classes(["form-group", "form-field"]),
    Specular$dDom$dElement.classWhenD(Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors)(field))("has-error"),
    labelVisible ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("form-field--inline")
  ])(Specular$dInternal$dRIO.bindImpl((() => {
    const $0 = dictFieldLabel.renderLabelWithMode(LabelDefault)(params.label);
    if (labelVisible) { return $0; }
    return Specular$dInternal$dRIO.pureImpl();
  })())(() => Specular$dInternal$dRIO.bindImpl(params.wrapper(widget(Data$dSemigroup.concatArray([Specular$dDom$dElement.class_("form-control")])(params.props))(field)))(() => displayErrors(dictHasErrors)(field))));
};
const textAreaField = dictHasErrors => dictFieldLabel => dictIsTextField => dictHasFieldId => () => () => Data$dNamedParams.mkNamedParamsFn()()({
  label: "",
  props: [],
  wrapper: x => x
})(textField$p(dictHasErrors)(dictHasFieldId)(dictFieldLabel)(Restaumatic$dForm$dWidgets.textArea(dictIsTextField)));
const textField = dictHasErrors => dictFieldLabel => dictIsTextField => dictHasFieldId => () => () => Data$dNamedParams.mkNamedParamsFn()()({label: "", props: [], wrapper: x => x})(textField$p(dictHasErrors)(dictHasFieldId)(dictFieldLabel)(Restaumatic$dForm$dWidgets.textInput(dictIsTextField)));
const translatedTextAreaField = dictAsTranslatedString => dictFieldLabel => () => () => params => {
  const $0 = {label: "", props: [], wrapper: translatedFieldWrapper, ...params};
  return textField$p(Restaumatic$dForm$dFormField.hasErrorsFormField)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p)(dictFieldLabel)(Restaumatic$dForm$dWidgets.textArea({
    textInput: v => Restaumatic$dForm$dTranslated.translatedTextInput(Restaumatic$dForm$dFormField.isRefLikeFormField$p)(Restaumatic$dForm$dFormField.hasContextFormField$p)(dictAsTranslatedString)(v)
  }))({field: $0.field, label: $0.label, props: $0.props, wrapper: $0.wrapper});
};
const translatedTextField = dictAsTranslatedString => dictFieldLabel => () => () => params => {
  const $0 = {label: "", props: [], wrapper: translatedFieldWrapper, ...params};
  return textField$p(Restaumatic$dForm$dFormField.hasErrorsFormField)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p)(dictFieldLabel)(Restaumatic$dForm$dWidgets.textInput({
    textInput: v => Restaumatic$dForm$dTranslated.translatedTextInput(Restaumatic$dForm$dFormField.isRefLikeFormField$p)(Restaumatic$dForm$dFormField.hasContextFormField$p)(dictAsTranslatedString)(v)
  }))({field: $0.field, label: $0.label, props: $0.props, wrapper: $0.wrapper});
};
const deleteButton = dictEq => item => Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.classes(["btn", "btn-default", "btn-sm"]),
  Specular$dDom$dElement.attr("type")("button"),
  Specular$dDom$dElement.onClick_(item.delete)
])(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.attr("aria-hidden")("true"),
  Specular$dDom$dElement.class_("icon-trash")
])(Restaumatic$dPrelude$dSpecular.wempty)))(Specular$dExtra.nbsp))(() => Specular$dDom$dElement.text("Usuń")));
const dateField = dictIsRefLike => dictHasErrors => dictAsDate => dictFieldLabel => dictHasFieldId => () => () => params => {
  const $0 = {label: "", placeholder: "", props: [], ...params};
  return textField$p(dictHasErrors)(dictHasFieldId)(dictFieldLabel)(Restaumatic$dForm$dWidgets.datePicker(dictIsRefLike)(dictAsDate))({
    field: $0.field,
    label: $0.label,
    props: [Specular$dDom$dElement.attr("placeholder")($0.placeholder), Data$dFoldable.foldableArray.foldMap(Specular$dDom$dElement.monoidProp)(x => x)($0.props)],
    wrapper: x => x
  });
};
const checkbox = dictFieldLabel => dictIsCheckboxField => () => () => params => {
  const $0 = {label: "", props: [], ...params};
  return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("checkbox")])(Specular$dDom$dElement.el_("label")(Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets.checkbox(dictIsCheckboxField)($0.props)($0.field))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => dictFieldLabel.renderLabelWithMode(LabelBooleanControl)($0.label)))));
};
const checkboxField = dictFieldLabel => dictFieldLabel1 => dictIsCheckboxField => dictHasErrors => dictHasFieldId => () => () => params => {
  const $0 = {label: "", title: "", props: [], ...params};
  const field = $0.field;
  return Specular$dDom$dElement.el("div")([
    Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(field),
    Specular$dDom$dElement.classes(["form-group", "form-field"]),
    Specular$dDom$dElement.classWhenD(Restaumatic$dForm$dInternal.hasDisplayedErrors(dictHasErrors)(field))("has-error")
  ])(Specular$dInternal$dRIO.bindImpl((() => {
    const $1 = dictFieldLabel1.renderLabelWithMode(LabelBooleanControl)($0.title);
    if (dictFieldLabel1.isVisible(LabelDefault)($0.title)) { return $1; }
    return Specular$dInternal$dRIO.pureImpl();
  })())(() => Specular$dInternal$dRIO.bindImpl(checkbox(dictFieldLabel)(dictIsCheckboxField)()()({label: $0.label, props: $0.props, field: $0.field}))(() => displayErrors(dictHasErrors)(field))));
};
const optionalWidget = label1 => f => renderSubform => Specular$dInternal$dRIO.bindImpl(checkboxField(labelString)(labelString)(Restaumatic$dForm$dFormField.isCheckboxFieldFormField$p)(Restaumatic$dForm$dFormField.hasErrorsFormField)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p)()()({
  label: label1,
  field: f.exists
}))(() => Specular$dFRP$dExtra.whenD({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))(false)(f.exists))(renderSubform(f.subform)));
const alertWarning = /* #__PURE__ */ Specular$dDom$dElement.el("div")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert"),
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert-warning")
]);
const displayAlertWarning = dictHasErrors => f => Specular$dFRP$dExtra.withUniqDynamic_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)({eq: Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)})(dictHasErrors.displayedErrors(f))(errors => Data$dFoldable.foldrArray(x => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)(alertWarning(Specular$dDom$dElement.text(x))))(b))(Specular$dInternal$dRIO.pureImpl())(errors));
const alertInfo = /* #__PURE__ */ Specular$dDom$dElement.el("div")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert"),
  /* #__PURE__ */ Specular$dDom$dElement.class_("alert-info")
]);
const addButton = dictOrd => dictShow => l => Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.classes(["btn", "btn-default", "btn-sm"]),
  Specular$dDom$dElement.attr("type")("button"),
  Specular$dDom$dElement.onClick_((() => {
    const $0 = l.generateId;
    return () => {
      const k = $0();
      Restaumatic$dForm$dList.addItem(dictOrd)(dictShow)(l)(k)();
    };
  })())
])(Specular$dInternal$dRIO.bindImpl(plusIcon)(() => Specular$dDom$dElement.text("Dodaj")));
export {
  $LabelMode,
  $UseDefault,
  LabelBooleanControl,
  LabelDefault,
  UseDefault,
  addButton,
  alertInfo,
  alertWarning,
  checkbox,
  checkboxField,
  dateField,
  deleteButton,
  displayAlertWarning,
  displayErrors,
  fieldset,
  fieldset$p,
  formGroup,
  infoText,
  isVisible,
  label,
  labelString,
  labelUnit,
  labelWidget,
  mappingField,
  optionalWidget,
  panel,
  panel$p,
  panelToggle,
  panel_,
  plusIcon,
  radioGroup,
  renderLabel,
  renderLabelWithMode,
  selectField,
  sortIcon,
  textAreaField,
  textField,
  textField$p,
  toGroupName,
  toGroupNameString,
  toGroupNameUseDefault,
  translatedFieldWrapper,
  translatedTextAreaField,
  translatedTextField,
  withNothing,
  wrapItem
};
